import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  BibliotecaInsumoArquivo,
  BibliotecaTicketArquivo,
  BibliotecaArquivoFiltros,
} from '../_models/biblioteca-arquivos';

@Injectable({
  providedIn: 'root',
})
export class BibliotecaArquivosService {
  constructor(private http: HttpClient) {}

  /**
   * Busca todos os arquivos de insumos com paginação e filtros
   */
  getInsumoArquivosPageable(
    page: number,
    size: number,
    sort: string,
    order: string,
    filtros: BibliotecaArquivoFiltros = {}
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('order', order);

    if (filtros.fileName) params = params.set('fileName', filtros.fileName);
    if (filtros.uploaderEmail)
      params = params.set('uploaderEmail', filtros.uploaderEmail);
    if (filtros.uploaderName)
      params = params.set('uploaderName', filtros.uploaderName);
    if (filtros.segment) params = params.set('segment', filtros.segment);
    if (filtros.status) params = params.set('status', filtros.status);
    if (filtros.competence)
      params = params.set('competence', filtros.competence);
    if (filtros.startDate) params = params.set('startDate', filtros.startDate);
    if (filtros.endDate) params = params.set('endDate', filtros.endDate);

    return this.http.get<any>(
      `${environment.apiUrl}/biblioteca/insumo-arquivos`,
      { params }
    );
  }

  /**
   * Busca todos os arquivos de tickets com paginação e filtros
   */
  getTicketArquivosPageable(
    page: number,
    size: number,
    sort: string,
    order: string,
    filtros: BibliotecaArquivoFiltros = {}
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('order', order);

    if (filtros.fileName) params = params.set('fileName', filtros.fileName);
    if (filtros.uploaderEmail)
      params = params.set('uploaderEmail', filtros.uploaderEmail);
    if (filtros.uploaderName)
      params = params.set('uploaderName', filtros.uploaderName);
    if (filtros.segment) params = params.set('segment', filtros.segment);
    if (filtros.status) params = params.set('status', filtros.status);
    if (filtros.category) params = params.set('category', filtros.category);
    if (filtros.subcategory)
      params = params.set('subcategory', filtros.subcategory);
    if (filtros.startDate) params = params.set('startDate', filtros.startDate);
    if (filtros.endDate) params = params.set('endDate', filtros.endDate);

    return this.http.get<any>(
      `${environment.apiUrl}/biblioteca/ticket-arquivos`,
      { params }
    );
  }

  /**
   * Download de arquivo de insumo
   */
  downloadInsumoAnexo(insumoId: number, anexoId: number, userId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/insumo/download/${userId}/${insumoId}/${anexoId}`
    );
  }

  /**
   * Download de arquivo de ticket
   */
  downloadTicketAnexo(ticketId: number, anexoId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/download/anexo/${anexoId}`,
      { params: new HttpParams().set('ticketId', ticketId.toString()) }
    );
  }

  /**
   * Exportar lista de arquivos de insumos para Excel
   */
  exportInsumoArquivosToExcel(filtros: BibliotecaArquivoFiltros = {}): Observable<Blob> {
    let params = new HttpParams();

    if (filtros.fileName) params = params.set('fileName', filtros.fileName);
    if (filtros.uploaderEmail)
      params = params.set('uploaderEmail', filtros.uploaderEmail);
    if (filtros.uploaderName)
      params = params.set('uploaderName', filtros.uploaderName);
    if (filtros.segment) params = params.set('segment', filtros.segment);
    if (filtros.status) params = params.set('status', filtros.status);
    if (filtros.competence)
      params = params.set('competence', filtros.competence);
    if (filtros.startDate) params = params.set('startDate', filtros.startDate);
    if (filtros.endDate) params = params.set('endDate', filtros.endDate);

    return this.http.get(
      `${environment.apiUrl}/biblioteca/insumo-arquivos/export`,
      { params, responseType: 'blob' }
    );
  }

  /**
   * Exportar lista de arquivos de tickets para Excel
   */
  exportTicketArquivosToExcel(filtros: BibliotecaArquivoFiltros = {}): Observable<Blob> {
    let params = new HttpParams();

    if (filtros.fileName) params = params.set('fileName', filtros.fileName);
    if (filtros.uploaderEmail)
      params = params.set('uploaderEmail', filtros.uploaderEmail);
    if (filtros.uploaderName)
      params = params.set('uploaderName', filtros.uploaderName);
    if (filtros.segment) params = params.set('segment', filtros.segment);
    if (filtros.status) params = params.set('status', filtros.status);
    if (filtros.category) params = params.set('category', filtros.category);
    if (filtros.subcategory)
      params = params.set('subcategory', filtros.subcategory);
    if (filtros.startDate) params = params.set('startDate', filtros.startDate);
    if (filtros.endDate) params = params.set('endDate', filtros.endDate);

    return this.http.get(
      `${environment.apiUrl}/biblioteca/ticket-arquivos/export`,
      { params, responseType: 'blob' }
    );
  }
}
